export default __webpack_public_path__ + "10ff79439d108bc99193e76120b38976.png";